import { createSignal } from 'solid-js';
import { createMagicDoorContext } from '~/contexts/utils';
import { AutoPayIncentiveSettingsRepository } from '~/repositories/settings/autoPayIncentiveSettingsRepository';
import type {
  AutoPayIncentivesSettings,
  AutoPayIncentivesSettingsCompanyPortalTypedSettingsWithOverridesDocument,
} from '~/swagger/settings/Api';
export const [AutoPayIncentiveSettingsProvider, useAutoPayIncentiveSettings] = createMagicDoorContext('AutoPayIncentiveSettings', () => {
  const repo = new AutoPayIncentiveSettingsRepository();

  const [isLoading, setIsLoading] = createSignal<boolean>(false);
  const [error, setError] = createSignal<Error | undefined>(undefined);
  const [allAutoPayIncentiveSettings, setAllAutoPayIncentiveSettings] = createSignal<
    AutoPayIncentivesSettingsCompanyPortalTypedSettingsWithOverridesDocument | undefined
  >();

  const getAllAutoPayIncentiveSettings = async () => {
    try {
      setIsLoading(true);
      const json = await repo.getAllAutoPayIncentiveSettings();
      setAllAutoPayIncentiveSettings(json);
    } catch (err) {
      setError(err instanceof Error ? err : new Error(String(err)));
    } finally {
      setIsLoading(false);
    }
  };

  const updateAutoPayIncentiveSettings = async (payload: AutoPayIncentivesSettings) => {
    try {
      setIsLoading(true);
      await repo.updateAutoPayIncentiveSettings(payload);
    } catch (err) {
      setError(err instanceof Error ? err : new Error(String(err)));
    } finally {
      setIsLoading(false);
    }
  };

  const updateOverrideAutoPayIncentiveSettings = async (level: string, levelId: string, payload: AutoPayIncentivesSettings) => {
    try {
      setIsLoading(true);
      await repo.updateAutoPayIncentiveSettingsByLevel(level, levelId, payload);
    } catch (err) {
      setError(err instanceof Error ? err : new Error(String(err)));
    } finally {
      setIsLoading(false);
    }
  };

  const addOverrideSettings = async (level: string, levelId: string, payload: AutoPayIncentivesSettings) => {
    try {
      setIsLoading(true);
      await repo.updateAutoPayIncentiveSettingsByLevel(level, levelId, payload);
    } catch (err) {
      setError(err instanceof Error ? err : new Error(String(err)));
    } finally {
      setIsLoading(false);
    }
  };

  const removeOverrideSettings = async (level: string, levelId: string) => {
    try {
      setIsLoading(true);
      await repo.deleteAutoPayIncentiveSettingsByLevel(level, levelId);
    } catch (err) {
      setError(err instanceof Error ? err : new Error(String(err)));
    } finally {
      setIsLoading(false);
    }
  };

  return {
    error,
    isLoading,
    allAutoPayIncentiveSettings,
    getAllAutoPayIncentiveSettings,
    updateAutoPayIncentiveSettings,
    addOverrideSettings,
    updateOverrideAutoPayIncentiveSettings,
    removeOverrideSettings,
  };
});
